import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RouterStateService } from './router-state.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private readonly httpClient = inject(HttpClient);
  private readonly routerStateService = inject(RouterStateService);

  public signIn(): void {
    this.executeSignIn('salesforce');
  }

  public signInWithSpid(): void {
    this.executeSignIn('salesforce_spid');
  }

  public executeSignIn(provider: string): void {
    const redirectUrl = this.routerStateService.redirectUrl() ?? '';

    if (redirectUrl) {
      document.location.href = `${environment.baseUrl}/authentication/oauth2/${provider}?redirect_url=${redirectUrl}`;
    } else {
      document.location.href = `${environment.baseUrl}/authentication/oauth2/${provider}`;
    }
  }

  public refreshSignIn(): Observable<unknown> {
    return this.httpClient.post<unknown>(
      `${environment.baseUrl}/authentication/sign-in/refresh`,
      {},
    );
  }

  public signOut(): Observable<unknown> {
    return this.httpClient.post<unknown>(
      `${environment.baseUrl}/authentication/sign-out`,
      {},
    );
  }
}
